// teamDisplay — the shared read-surface helpers of a team: the status badge and
// the time zone's word, reused by the list, the peek and the page so a team reads
// identically wherever it appears.

import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Badge, type BadgeProps } from '../../components/ui/Badge.js';
import { timezoneLabel } from '../../lib/format.js';

export function TeamStatusBadge({ disabled, appearance }: { disabled: boolean; appearance?: BadgeProps['appearance'] }) {
  const { t } = useTranslation('teams');
  const label = disabled ? t('status.disabled') : t('status.active');
  return (
    <Badge variant={disabled ? 'warning' : 'success'} appearance={appearance ?? 'subtle'} title={appearance === 'dot' ? label : undefined}>
      {label}
    </Badge>
  );
}

/** The team's clock in words: its own zone, or "Project time" when it works on the project's (ADR-082 §2 — NULL = the project's). */
export function teamZoneWord(t: TFunction, timezone: string | null): string {
  return timezone ? timezoneLabel(timezone) : t('zone.project');
}
